var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.875 156.146L114 184.2L64.125 156.146V126.505L49.875 118.588V164.479L114 200.549L178.125 164.479V118.588L163.875 126.505V156.146Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 20.4741L14.25 72.1963V84.5466L114 139.962L199.5 92.4633V131.812H213.75V72.1963L114 20.4741ZM185.25 84.0785L171 91.9949L114 123.663L57 91.9949L42.75 84.0785L32.8734 78.5914L114 36.5259L195.127 78.5914L185.25 84.0785Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapGrey);
export default __webpack_public_path__ + "static/media/capGrey.850d4e3b469782a157e6513418ecf300.svg";
export { ForwardRef as ReactComponent };